import React, { useEffect, useState } from "react";
import WorkspaceSwitch from "../../Components/WorkspaceSwitch";
import Avatar from "../../Components/Avatar";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { LoadingCircle } from "../../Components/LoadingCircle";
import PeerConnectionManager from "../../Services/PeerConnectionManager";
import Text from "../../Components/Text";
import Button from "../../Components/Buttons/Button";
import { usePeerConnection } from "../../Context/PeerConnectionContext";
import { getUser } from "../../Helper/workspaceStorage";

const MainLayout = () => {
  const navigate = useNavigate();
  const [user] = useState(getUser());

  const {isConnected} = usePeerConnection();

  useEffect(() => {
    if (!user && !PeerConnectionManager.isConnected()) {
      navigate("/app/login");
      return;
    }
  }, [user, navigate]);

  function handleClose (){
    PeerConnectionManager.close()
    window.location.reload()
  }

  if (!user)
    return <LoadingCircle />;

  return (
    <div className="flex flex-col h-full w-full bg-white">
      {/* Navbar */}

      {isConnected ? (
        <div className="flex items-center justify-between p-3 border-b border-gray-200">
          <Text type="main">
            Remote Verbindung
          </Text>
          <Button text={"Verbindung Schliessen"} buttonColor="bg-red-200" onClickAction={() => handleClose()} />
        </div>
      ) : (
        <div className="flex items-center justify-between p-3 border-b border-gray-200">
          <WorkspaceSwitch />
          <Avatar
            firstname={
              user.firstName
            }
            lastname={
              user.lastName
            }
          />
        </div>
      )}

      {/* Content */}
      <div className="flex-1 h-full overflow-auto">
        <div className="w-full h-full flex flex-row">
          <Sidebar />
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export default MainLayout;